module.exports = __webpack_public_path__ + "img/ryerson-university-logo.3dd701bb.jpg";